import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-kiosk-activity-log',
    templateUrl: './breadcrumb.kiosk.activity.log.component.html'
})

export class BreadcrumbKioskActivityLogComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() facilityId: number;
    @Input() kioskId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
